var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tag",
    {
      attrs: {
        effect: "dark",
        type: _vm._f("statusColorFilter")(_vm.status, _vm.updatedAt),
      },
    },
    [
      _c("strong", [
        _vm._v(
          " " + _vm._s(_vm._f("statusFilter")(_vm.status, _vm.updatedAt)) + " "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }